import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { BuilderComponent, builder, useIsPreviewing } from "@builder.io/react";
import "./builder-registry";
import Layout from "./Layout";

const App = () => {
  const isPreviewingInBuilder = useIsPreviewing();
  const [notFound, setNotFound] = useState(false);
  const [content, setContent] = useState(null);

  useEffect(() => {
    async function fetchContent() {
      const content = await builder
        .get("mg", {
          url: window.location.pathname
        })
        .promise();

      setContent(content);
      setNotFound(!content);

      if (content?.data.pageTitle) {
        console.log(content.data.pageTitle)
        document.title = content.data.pageTitle;
      }

      setTimeout(() => {
        if (window && window.Invoca) {
          window.Invoca.PNAPI.run();
        }
      }, 500);
    }
    fetchContent();
  }, [window.location.pathname]);

  return (
    <Router basename="/">
      <Layout>
        <Routes>
          <Route path="*" element={<BuilderComponent model="mg" />} />
        </Routes>
      </Layout>
    </Router>
  )
};

export default App;
